/**
 * src/lib/offline/taskCache.js — task-bound view of the generic entity cache.
 *
 * Thin wrapper over makeEntityCache('tasks'); kept as a named module so the
 * task hook + Phase-1 tests have a stable surface. New domains should use
 * makeEntityCache(<collection>) / reconcileCollection() directly.
 */

import { makeEntityCache } from './entityCache';

const taskCache = makeEntityCache('tasks');

/** Replace the cache with the given task rows. Best-effort, tolerant of junk. */
export async function writeTasksCache(tasks) {
  return taskCache.write(tasks);
}

/** Read all cached tasks. Returns [] on any error. */
export async function readTasksCache() {
  return taskCache.read();
}

/** Empty the task cache. */
export async function clearTasksCache() {
  return taskCache.clear();
}

/**
 * Decide what task list to return for a fetch, and update the cache.
 * @param {{ fetched: any[], online: boolean }} input
 * @returns {Promise<{ tasks: any[], fromCache: boolean }>}
 */
export async function reconcileFetch({ fetched, online }) {
  const { rows, fromCache } = await taskCache.reconcile({ fetched, online });
  return { tasks: rows, fromCache };
}
